module.exports = __webpack_public_path__ + "img/code-js-sm.2a5ffd98.webp";